import { FormData, SetFormData } from "./FormData.tsx";
import { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import workspaceTypesStatic from "../../../assets/WorkspaceTypes.tsx";

interface Step2WorkspaceTypeProps {
  formData: FormData;
  setFormData: SetFormData;
  setNextDisabled: React.Dispatch<React.SetStateAction<boolean>>;
}

interface WorkspaceType {
  id: number;
  title: string;
  description: string;
  hoverDescription?: string;
  image?: React.ComponentType<{ className?: string }>;
}

export default function WorkspaceType({
  formData,
  setFormData,
  setNextDisabled,
}: Step2WorkspaceTypeProps) {
  const [workspaceTypes, setWorkspaceTypes] = useState<WorkspaceType[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const handleInputChange = (value: number | null) => {
    setFormData((prev) => ({
      ...prev,
      workspaceTypeId: value,
    }));
  };

  const handleSpaceClick = (value: number | null) => {
    handleInputChange(formData.workspaceTypeId === value ? null : value);
  };

  useEffect(() => {
    setNextDisabled(formData.workspaceTypeId == null);
  }, [formData.workspaceTypeId]);

  useEffect(() => {
    const fetchWorkspaceTypes = async () => {
      try {
        const token = Cookies.get("authToken");
        const response = await axios.get<WorkspaceType[]>(
          "/api/workspacetypes/listWorkspaceTypes",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setWorkspaceTypes(response.data);
        console.log("Fetched workspace types:", response.data);
      } catch (err) {
        setError("Failed to load workspace types");
        console.error("Error fetching workspace types:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchWorkspaceTypes();
  }, []);
  if (loading) {
    return <div>Loading workspace types...</div>;
  }

  if (error) {
    return <div className="text-red-500">{error}</div>;
  }

  if (workspaceTypes.length === 0) {
    return <div>No workspace types available</div>;
  }
  return (
    <>
      {workspaceTypes
        .filter((space) => space.id !== null)
        .map((space) => {
          const IconComponent =
            workspaceTypesStatic.find((type) => type.value === space.id)
              ?.icon || null;
          return (
            <div
              key={space.id}
              onClick={() => handleSpaceClick(space.id)}
              className={`p-4 border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-50 transition-colors ${
                formData.workspaceTypeId === space.id
                  ? "outline-2 outline-black bg-gray-100"
                  : ""
              }`}
            >
              <div className="flex items-center gap-3">
                {IconComponent && <IconComponent className="h-6 w-6 mr-3" />}
                <div>
                  <h3 className="text-lg font-medium">{space.title}</h3>
                  <p className="text-gray-600">{space.description}</p>
                  <p className="mt-2 text-sm text-gray-500 hidden group-hover:block">
                    {space.hoverDescription}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
    </>
  );
}
